<form
  [formGroup]="form"
  #formRef="ngForm"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
  [canEdit]="[accessRights.RolePermissions_write]"
  [patchForm]="tile"
>
  <!--New VIEW-->
  <div class="card-body">
    <div class="form-check mb-4">
      <input
        type="checkbox"
        class="form-check-input"
        [id]="'isActive' + form.controls.order.value"
        formControlName="isActive"
      />

      <label
        [for]="'isActive' + form.controls.order.value"
        class="form-check-label ms-2 cursor-pointer"
        >{{ 'general.isActive' | translate | titlecase }}</label
      >
    </div>

    <div class="row">
      <nav
        class="mb-4"
        attr.aria-label="{{ 'wcag.translationLangMenu' | translate }}"
      >
        <ul class="nav nav-tabs" role="tablist">
          <li
            *ngFor="let language of ISO639LanguageCodes; let i = index"
            class="nav-item"
          >
            <a
              href="javascript:;"
              class="nav-link position-relative"
              [ngClass]="langSelected == ISO639LanguageCodes[i] ? 'active' : ''"
              (click)="setLanguageSelected(ISO639LanguageCodes[i])"
              role="tab"
              [attr.aria-selected]="
                langSelected == ISO639LanguageCodes[i] ? 'true' : 'false'
              "
            >
              <span [ngClass]="'flag flag-' + language" role="img">
                <!-- WCAG missing aria-label for flag -->
              </span>
              <span
                class="invalid-feedback"
                role="alert"
                aria-atomic="true"
                *ngIf="
                  form.controls['description_' + language].invalid ||
                  form.controls['subtitle_' + language].invalid
                "
              >
                <i
                  role="img"
                  class="fas fa-exclamation-circle"
                  attr.aria-label="{{ 'wcag.missingTranslation' | translate }}"
                ></i>
              </span>
            </a>
          </li>
        </ul>
      </nav>

      <!-- title-->
      <div class="mb-4 col-xxl-9">
        <label class="form-label">
          {{ 'shopModule.tileTitle' | translate }}
        </label>
        <div *ngIf="langSelected == 'nl' && availableLanguages['nl']">
          <div
            [ngxSummernote]="config"
            [ngxSummernoteDisabled]="
              !(
                accessRightService.isAllowedByAccessRight([
                  accessRights.RolePermissions_write
                ]) | async
              )
            "
            formControlName="description_nl"
            [attr.aria-invalid]="
              form.controls.description_nl.dirty &&
              form.controls.description_nl.invalid &&
              form.controls.description_nl.errors
                ? 'true'
                : null
            "
          ></div>
          <span
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.description_nl.dirty &&
              form.controls.description_nl.invalid
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'surveyModule.description' | translate }}
            {{ 'general.isInvalid' | translate }}
          </span>
        </div>
        <div *ngIf="langSelected == 'en' && availableLanguages['en']">
          <div
            [ngxSummernote]="config"
            [ngxSummernoteDisabled]="
              !(
                accessRightService.isAllowedByAccessRight([
                  accessRights.RolePermissions_write
                ]) | async
              )
            "
            formControlName="description_en"
            [attr.aria-invalid]="
              form.controls.description_en.dirty &&
              form.controls.description_en.invalid &&
              form.controls.description_en.errors
                ? 'true'
                : null
            "
          ></div>
          <span
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.description_en.dirty &&
              form.controls.description_en.invalid
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'surveyModule.description' | translate }}
            {{ 'general.isInvalid' | translate }}
          </span>
        </div>
        <div *ngIf="langSelected == 'de' && availableLanguages['de']">
          <div
            [ngxSummernote]="config"
            [ngxSummernoteDisabled]="
              !(
                accessRightService.isAllowedByAccessRight([
                  accessRights.RolePermissions_write
                ]) | async
              )
            "
            formControlName="description_de"
            [attr.aria-invalid]="
              form.controls.description_de.dirty &&
              form.controls.description_de.invalid &&
              form.controls.description_de.errors
                ? 'true'
                : null
            "
          ></div>
          <span
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.description_de.dirty &&
              form.controls.description_de.invalid
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'surveyModule.description' | translate }}
            {{ 'general.isInvalid' | translate }}
          </span>
        </div>
        <div *ngIf="langSelected == 'fr' && availableLanguages['fr']">
          <div
            [ngxSummernote]="config"
            [ngxSummernoteDisabled]="
              !(
                accessRightService.isAllowedByAccessRight([
                  accessRights.RolePermissions_write
                ]) | async
              )
            "
            formControlName="description_fr"
            [attr.aria-invalid]="
              form.controls.description_fr.dirty &&
              form.controls.description_fr.invalid &&
              form.controls.description_fr.errors
                ? 'true'
                : null
            "
          ></div>
          <span
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.description_fr.dirty &&
              form.controls.description_fr.invalid
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'surveyModule.description' | translate }}
            {{ 'general.isInvalid' | translate }}
          </span>
        </div>
      </div>

      <!-- subtitle-->
      <div class="mb-4 col-xxl-9">
        <label class="form-label">
          {{ 'shopModule.tileSubtitle' | translate }}
        </label>
        <div *ngIf="langSelected == 'nl' && availableLanguages['nl']">
          <div
            [ngxSummernote]="config"
            [ngxSummernoteDisabled]="
              !(
                accessRightService.isAllowedByAccessRight([
                  accessRights.RolePermissions_write
                ]) | async
              )
            "
            formControlName="subtitle_nl"
            [attr.aria-invalid]="
              form.controls.subtitle_nl.dirty &&
              form.controls.subtitle_nl.invalid &&
              form.controls.subtitle_nl.errors
                ? 'true'
                : null
            "
          ></div>
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.subtitle_nl.dirty &&
              form.controls.subtitle_nl.invalid
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'surveyModule.subtitle' | translate }}
            {{ 'general.isInvalid' | translate }}
          </p>
        </div>
        <div *ngIf="langSelected == 'en' && availableLanguages['en']">
          <div
            [ngxSummernote]="config"
            [ngxSummernoteDisabled]="
              !(
                accessRightService.isAllowedByAccessRight([
                  accessRights.RolePermissions_write
                ]) | async
              )
            "
            formControlName="subtitle_en"
            [attr.aria-invalid]="
              form.controls.subtitle_en.dirty &&
              form.controls.subtitle_en.invalid &&
              form.controls.subtitle_en.errors
                ? 'true'
                : null
            "
          ></div>
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.subtitle_en.dirty &&
              form.controls.subtitle_en.invalid
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'surveyModule.subtitle' | translate }}
            {{ 'general.isInvalid' | translate }}
          </p>
        </div>
        <div *ngIf="langSelected == 'de' && availableLanguages['de']">
          <div
            [ngxSummernote]="config"
            [ngxSummernoteDisabled]="
              !(
                accessRightService.isAllowedByAccessRight([
                  accessRights.RolePermissions_write
                ]) | async
              )
            "
            formControlName="subtitle_de"
            [attr.aria-invalid]="
              form.controls.subtitle_de.dirty &&
              form.controls.subtitle_de.invalid &&
              form.controls.subtitle_de.errors
                ? 'true'
                : null
            "
          ></div>
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.subtitle_de.dirty &&
              form.controls.subtitle_de.invalid
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'surveyModule.subtitle' | translate }}
            {{ 'general.isInvalid' | translate }}
          </p>
        </div>
        <div *ngIf="langSelected == 'fr' && availableLanguages['fr']">
          <div
            [ngxSummernote]="config"
            [ngxSummernoteDisabled]="
              !(
                accessRightService.isAllowedByAccessRight([
                  accessRights.RolePermissions_write
                ]) | async
              )
            "
            formControlName="subtitle_fr"
            [attr.aria-invalid]="
              form.controls.subtitle_fr.dirty &&
              form.controls.subtitle_fr.invalid &&
              form.controls.subtitle_fr.errors
                ? 'true'
                : null
            "
          ></div>
          <p
            class="invalid-feedback"
            role="alert"
            aria-atomic="true"
            *ngIf="
              form.controls.subtitle_fr.dirty &&
              form.controls.subtitle_fr.invalid
            "
          >
            <i
              role="img"
              class="fas fa-exclamation-circle"
              aria-hidden="true"
            ></i>
            {{ 'surveyModule.subtitle' | translate }}
            {{ 'general.isInvalid' | translate }}
          </p>
        </div>
      </div>

      <!-- Image -->
      <div class="mb-4">
        <label class="form-label">
          <span
            class="text-danger"
            attr.aria-label="{{ 'general.required' | translate }}"
            >*</span
          >
          {{ 'general.image' | translate }}
          <small>({{ 'general.isRequired' | translate }})</small>
        </label>
        <div class="row justify-content-between">
          <div class="col-lg-6 col-xl-4 mb-2 mb-lg-0">
            <img
              class="rounded img-fluid"
              [src]="getImageUrl(form.controls.imagePath.value)"
              alt="{{ 'wcag.specialShopTileImage' | translate }}"
            />
          </div>
          <div class="col-lg-6" [canSee]="[accessRights.RolePermissions_write]">
            <upload-file
              [imageSize]="'500x450 px'"
              (onSubmitFile)="onSubmitImage($event)"
            >
            </upload-file>
          </div>

          <p
            class="text-danger"
            *ngIf="
              form.controls.imagePath.dirty && form.controls.imagePath.invalid
            "
          >
            {{ 'general.image' | translate }}
            {{ 'general.isRequired' | translate }}
          </p>
        </div>
      </div>

      <!-- Permissions -->
      <div class="mb-4">
        <label class="form-label">{{
          'shopModule.rolePermissions' | translate
        }}</label>

        <role-permission-select-input
          [rolePermissions]="rolePermissions$ | async"
          formControlName="permissionIds"
          [allowClearing]="true"
          style="width: 100%"
        ></role-permission-select-input>
      </div>
    </div>
  </div>
  <!--End New VIEW-->
</form>
